function checkCart() {
    var cart = Shopify.checkout ? Shopify.checkout.line_items : [];
    var totalItems = 0;
    cart.forEach(function(item) {
        totalItems += item.quantity;
    });

    if (totalItems >= 5) {
        showPopup(); // Show the popup if 6 or more items are in the cart
    }
}

// Function to show the popup
function showPopup() {
    var popup = document.getElementById('popup-container');
    popup.style.display = 'block';
}

// Close the popup
function closePopup() {
    var popup = document.getElementById('popup-container');
    popup.style.display = 'none';
}

// Wait for the page to load and then check the cart
window.onload = function() {
    checkCart();
};